import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from './helpers'

// User

export const GET_USER = 'get user'
export const getUser = fsa(GET_USER)

export const GET_USER_FAILURE = 'get user failure'
export const getUserFailure = fsaError(GET_USER_FAILURE)

export const GET_USER_PENDING = 'get user pending'
export const getUserPending = fsa(GET_USER_PENDING)

export const GET_USER_SUCCESS = 'get user success'
export const getUserSuccess = fsaPayload(GET_USER_SUCCESS)

// Event

export const GET_CHECKOUT_MESSAGE_FAILURE = 'get checkout message failure'
export const getCheckoutMessageFailure = fsaError(GET_CHECKOUT_MESSAGE_FAILURE)

export const GET_CHECKOUT_MESSAGE_PENDING = 'get checkout message pending'
export const getCheckoutMessagePending = fsa(GET_CHECKOUT_MESSAGE_PENDING)

export const GET_CHECKOUT_MESSAGE_SUCCESS = 'get checkout message success'
export const getCheckoutMessageSuccess = fsaPayload(GET_CHECKOUT_MESSAGE_SUCCESS)

export const GET_CURRENT_EVENT = 'get current event'
export const getCurrentEvent = fsa(GET_CURRENT_EVENT)

export const GET_CURRENT_EVENT_FAILURE = 'get current event failure'
export const getCurrentEventFailure = fsaError(GET_CURRENT_EVENT_FAILURE)

export const GET_CURRENT_EVENT_PENDING = 'get current event pending'
export const getCurrentEventPending = fsa(GET_CURRENT_EVENT_PENDING)

export const GET_CURRENT_EVENT_SUCCESS = 'get current event success'
export const getCurrentEventSuccess = fsaPayload(GET_CURRENT_EVENT_SUCCESS)

export const GET_SOONEST_EVENT_DATE = 'get soonest event date'
export const getSoonestEventDate = fsa(GET_SOONEST_EVENT_DATE)

export const GET_SOONEST_EVENT_DATE_FAILURE = 'get soonest event date failure'
export const getSoonestEventDateFailure = fsaError(GET_SOONEST_EVENT_DATE_FAILURE)

export const GET_SOONEST_EVENT_DATE_PENDING = 'get soonest event date pending'
export const getSoonestEventDatePending = fsa(GET_SOONEST_EVENT_DATE_PENDING)

export const GET_SOONEST_EVENT_DATE_SUCCESS = 'get soonest event date success'
export const getSoonestEventDateSuccess = fsaPayload(GET_SOONEST_EVENT_DATE_SUCCESS)

// Looks

export const CREATE_EVENT_LOOK = 'create event look'
export const createEventLook = fsaPayloadByKeys(CREATE_EVENT_LOOK, ['lookName', 'origin', 'isHto'])

export const CREATE_EVENT_LOOK_FAILURE = 'create event look failure'
export const createEventLookFailure = fsaError(CREATE_EVENT_LOOK_FAILURE)

export const CREATE_EVENT_LOOK_PENDING = 'create event look pending'
export const createEventLookPending = fsa(CREATE_EVENT_LOOK_PENDING)

export const CREATE_EVENT_LOOK_SUCCESS = 'create event look succeeded'
export const createEventLookSuccess = fsaPayload(CREATE_EVENT_LOOK_SUCCESS)

export const GET_EVENT_LOOKS = 'get event looks by eventId'
export const getEventLooks = fsaPayloadByKeys(GET_EVENT_LOOKS, ['eventId'])

export const GET_EVENT_LOOKS_FAILURE = 'get event looks failure'
export const getEventLooksFailure = fsaError(GET_EVENT_LOOKS_FAILURE)

export const GET_EVENT_LOOKS_PENDING = 'get event looks pending'
export const getEventLooksPending = fsa(GET_EVENT_LOOKS_PENDING)

export const GET_EVENT_LOOKS_SUCCESS = 'get event looks succeeded'
export const getEventLooksSuccess = fsaPayload(GET_EVENT_LOOKS_SUCCESS)

// Login

export const LOGIN = 'login'
export const login = fsaPayloadByKeys(LOGIN, ['email', 'location', 'password'])

export const LOGIN_FAILURE = 'login failure'
export const loginFailure = fsaError(LOGIN_FAILURE)

export const LOGIN_PENDING = 'login pending'
export const loginPending = fsa(LOGIN_PENDING)

export const LOGIN_SUCCESS = 'login success'
export const loginSuccess = fsaPayload(LOGIN_SUCCESS)

// Registration

export const REGISTRATION = 'registration'
/**
 * @param {Object} payload
 * @param {String} payload.email        User's email to register
 * @param {Number} [payload.eventType]  Used for analytics _only_
 * @param {String} [payload.eventRole]  Used for analytics _only_
 * @param {String} [payload.experiment] Used primarily for hidePasswordV2 experiment currently
 * @param {String} payload.location     Which form was registration called from?
 * @param {String} payload.password     User's desired password
 */
export const registration = fsaPayload(REGISTRATION)

export const REGISTRATION_FAILURE = 'registration failure'
export const registrationFailure = fsaError(REGISTRATION_FAILURE)

export const REGISTRATION_PENDING = 'registration pending'
export const registrationPending = fsa(REGISTRATION_PENDING)

export const REGISTRATION_SUCCESS = 'registration success'
export const registrationSuccess = fsaPayload(REGISTRATION_SUCCESS)

// Registration w/ Existing Email

export const REGISTRATION_WITH_EXISTING_EMAIL = 'registration with existing email'
export const registrationExistingEmail = fsaPayloadByKeys(REGISTRATION_WITH_EXISTING_EMAIL, [
  'email',
  'location',
  'password',
])

// Participant Login & Registration

export const CLEAR_PARTICIPANT_INFO = 'clear participant info'
export const clearParticipantInfo = fsa(CLEAR_PARTICIPANT_INFO)

export const GET_PARTICIPANT_INFO = 'get participant info'
export const getParticipantInfo = fsaPayloadByKeys(GET_PARTICIPANT_INFO, ['token'])

export const GET_PARTICIPANT_INFO_FAILURE = 'get participant info failure'
export const getParticipantInfoFailure = fsaError(GET_PARTICIPANT_INFO_FAILURE)

export const GET_PARTICIPANT_INFO_PENDING = 'get participant info pending'
export const getParticipantInfoPending = fsa(GET_PARTICIPANT_INFO_PENDING)

export const GET_PARTICIPANT_INFO_SUCCESS = 'get participant info success'
export const getParticipantInfoSuccess = fsaPayload(GET_PARTICIPANT_INFO_SUCCESS)

// Password Reset Request

export const PASSWORD_RESET_REQUEST = 'password reset request'
export const passwordResetRequest = fsaPayloadByKeys(PASSWORD_RESET_REQUEST, ['email', 'location'])

export const PASSWORD_RESET_REQUEST_FAILURE = 'password reset request failure'
export const passwordResetRequestFailure = fsaError(PASSWORD_RESET_REQUEST_FAILURE)

export const PASSWORD_RESET_REQUEST_PENDING = 'password reset request pending'
export const passwordResetRequestPending = fsa(PASSWORD_RESET_REQUEST_PENDING)

export const PASSWORD_RESET_REQUEST_SUCCESS = 'password reset request success'
export const passwordResetRequestSuccess = fsaPayload(PASSWORD_RESET_REQUEST_SUCCESS)
